import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import styles from './Layout.module.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.innerWidth >= 1024;
  });

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const shouldShowNavigation = useMemo(() => {
    if (isDesktop) {
      return true;
    }

    const path = location.pathname;
    
    // 主要页面
    if (path === '/' || path === '/discover' || path === '/profile') {
      return true;
    }
    
    // 历史记录相关页面
    if (path === '/history' || path.startsWith('/history/')) {
      return true;
    }
    
    // Profile 子页面
    if (path.startsWith('/profile/')) {
      return true;
    }
    
    // 小说投票页面
    if (path === '/novel-voting') {
      return true;
    }
    
    // 关于我们
    if (path === '/about') {
      return true;
    }
    
    // 分类相关
    if (path.startsWith('/categories/')) {
      return true;
    }
    
    // 书籍详情
    if (path.startsWith('/book/')) {
      return true;
    }
    
    // 管理员页面
    if (path === '/admin' || path.startsWith('/admin/')) {
      return true;
    }
    
    return false;
  }, [isDesktop, location.pathname]);
  
  return (
    <div className={styles.layout}>
      <main className={`${styles.layoutMain} ${shouldShowNavigation ? styles.withNavigation : styles.withoutNavigation}`}>
        <div className={styles.container}>
          {children}
        </div>
      </main>
      
      {/* 只在指定页面显示导航栏 */}
      {shouldShowNavigation && <Navigation />}
    </div>
  );
};

export default Layout;
